import React from 'react';
import './TimePill.css';

/**
 * Wiederverwendbarer Pill-Toggle (z.B. fuer "IST | SOLL | Vergleich").
 *
 * @param {{
 *   value: string,
 *   options: Array<{ id: string, label: string, title?: string }>,
 *   onChange: (id: string) => void,
 *   darkMode?: boolean,
 *   ariaLabel?: string,
 * }} props
 */
function TimePill({ value, options, onChange, darkMode = false, ariaLabel }) {
  return (
    <div className={`time-pill ${darkMode ? 'dark-mode' : ''}`} role="group" aria-label={ariaLabel || 'Zeit-Modus'}>
      {options.map(opt => (
        <button
          key={opt.id}
          type="button"
          className={`time-pill-btn ${value === opt.id ? 'active' : ''}`}
          onClick={(e) => { e.stopPropagation(); onChange(opt.id); }}
          title={opt.title || opt.label}
          aria-pressed={value === opt.id}
        >{opt.label}</button>
      ))}
    </div>
  );
}

export default TimePill;
